






















import { defineComponent } from '@nuxtjs/composition-api'
import { IBlockVideoPopup } from '@/contracts/BlockVideoPopup'
import { defineProps } from '@/helpers/defineProps'
import Popup from '@/packages/basis/components/Popup.vue'

export default defineComponent({
  name: 'BlockVideoPopup',
  components: { Popup },
  props: defineProps<IBlockVideoPopup>({
    videoLink: {
      default: '',
    },
    open: {
      default: false,
    },
  }),
  setup(_, { emit }) {
    const closePopupHandler = () => {
      emit('close')
    }
    return {
      closePopupHandler,
    }
  },
})
